import { getApiKey } from 'utils/environment';

export const GOOGLE_MAPS_API_BASE_URL = 'https://www.bojangles-us.com/_gmaps/maps/api';

export const GET_CURRENT_POSITION_TIMEOUT = 5000;

export const getGoogleApiSrcPath = () => {
  const googleMapsApiKey = getApiKey('googleMapsWeb');
  // Google serves US-biased place names (e.g. "Lake America") unless biased to a ccTLD.
  // Every market this site serves is Canadian, so the bias is always CA.
  return `${GOOGLE_MAPS_API_BASE_URL}/js?key=${googleMapsApiKey}&libraries=places&region=CA`;
};
